<template>
    <div class="text-center">
        <v-dialog
            v-model="dialog"
            @click:outside="onClose"
            width="800"
        >
            <v-card>
                <v-card-title class="headline lighten-2">
                    <div class="actionHeader">
                        <span>Actions</span>
                        <div class="actionHeader_right">
                            <v-btn
                                color="green"
                                x-small
                                @click="onAddAction"
                                :disabled="!permissions['9']"
                            >
                                <v-icon>mdi-plus</v-icon>
                                <span>Add action</span>
                            </v-btn>
                            <v-btn

                                icon
                                fab
                                x-small
                                @click="onClose"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card-title>
                <actions-table
                    :listItems="shortPaymentsActions"
                    @updateEditActions="onEditActions"
                    @onDeleteAction="deleteAction"
                    :permissions="permissions"
                ></actions-table>
            </v-card>
            <actions-drawer
                v-if="isDrawer"
                :dataActions="dataActions"
                :editAction="editAction"
                :isDrawer="isDrawer"
                @closeDrawer="onDrawer"
                :dataSort="dataSort"
            ></actions-drawer>
        </v-dialog>
    </div>
</template>

<script>
const ActionsDrawer = () => import('@/components/Accounting/ShortPayments/ActionDrawer/ActionDrawer');
import ActionsTable from "@/components/Accounting/ShortPayments/ActionsTable/ActionsTable";

export default {
	name: "ActionsPopup",
	components: {
		ActionsDrawer,
		ActionsTable
	},
	props: {
		isDialog: Boolean,
		actions: Object,
		dataActions: Object,
		shortPaymentsActions: Array,
		dataSort: Object,
		permissions: Object
	},
	data: () => ({
		dialog: false,
		isDrawer: null,
		editAction: null
	}),
	methods: {
		deleteAction(value) {
			this.$emit('actionDelete', value);
		},
		onEditActions(values) {
			this.editAction = values;
			this.isDrawer = true;
		},
		onClose() {
			this.editAction = null;
			this.$emit('updateClose');
		},
		onDrawer(mark) {
			this.editAction = null;
			this.isDrawer = false;
			if (mark) this.onClose();
		},
		onAddAction() {
			this.isDrawer = true;
		}
	},
	mounted() {
		this.dialog = this.isDialog;
	}
};
</script>

<style scoped lang="scss">
.actionHeader {
    display: flex;
    justify-content: space-between;
    width: 100%;

    &_right {
        [type="button"] {
            margin-left: 10px;
        }
    }
}
</style>
